<ng-container *ngIf="passwordUpdateRequired$ | async as passwordUpdateRequired">
  <py-alert-message
    *ngIf="passwordUpdateRequired"
    [title]="'password.changeRequired_title' | cxTranslate"
    [body]="'password.changeRequired_text' | cxTranslate"
    type="danger"
    [dismissable]="false"
  ></py-alert-message>
</ng-container>
